<template>
  <div class="bill-disbursement page-content">
    <!-- <div class='col-md-12'>
        <div class='row'>
          <div class='col-md-6 float-start'>
            <h1 class='mt-2'>Attendance of Partners</h1>
          </div>
        </div>
      </div> -->
    <div class="disbursement-tab">
      <AttendancePagesHeading
        pageName="Disbursement"
        :date="date"
        :filterOptions="[
          { name: 'Filter Status', value: 'status' },
          { name: 'Download Status', value: 'downloadStatus' }
        ]"
        @filterSearch="filterSearch"
        @sync="getDisbursementList"
        @changeDate="changeDate"
      ></AttendancePagesHeading>

      <!-- <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-4">
                <div class="row">
                  <div class="col-md-auto">
                    <nav>
                      <div
                        class="nav nav-tabs attendance-tabs"
                        id="nav-tab"
                        role="tablist"
                      >
                        <router-link
                          to="/trip-request/partners-attendance"
                          class="nav-link"
                          >Attendance
                        </router-link>

                        <router-link
                          to="/trip-request/partners/bill/view"
                          class="nav-link"
                          >Bill
                        </router-link>

                        <router-link
                          to="/trip-request/partners/disbursement/view"
                          class="nav-link active"
                          >Disbursement
                        </router-link>
                      </div>
                    </nav>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <div class="row">
                  <div class="col-md-2">
                    <button
                      class="btn btn-light"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#filterCollapse"
                      aria-expanded="false"
                      aria-controls="filterCollapse"
                    >
                      <i class="bi bi-funnel-fill"></i> Filter
                    </button>
                  </div>
                  <div class="col-md-5">
                    <Datepicker
                      v-model="date"
                      weekPicker
                      range
                      weekStart="4"
                      :enableTimePicker="false"
                    />
                  </div>
                  <div class="col-md-2">
                    <button
                      type="button"
                      @click="pageReload"
                      class="btn btn-light"
                    >
                      <i class="bi bi-arrow-clockwise"></i> Reload
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="collapse" id="filterCollapse">
              <div class="card card-body mt-1">
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-6">
                        <Multiselect
                          v-model="disbursementFilter.status"
                          :closeOnSelect="true"
                          :searchable="true"
                          :options-limit="20"
                          :options="statusOption"
                          :loading="true"
                          placeholder="Filter Status"
                        />
                      </div>
                      <div class="col-6">
                        <Multiselect
                          v-model="disbursementFilter.downloadStatus"
                          :closeOnSelect="true"
                          :searchable="true"
                          :options-limit="20"
                          :options="downloadOption"
                          :loading="true"
                          placeholder="Download Status"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

      <div class="disbursement-table">
        <div class="card">
          <div class="card-body">
            <div v-if="isLoading" class="container">
              <DefaultLoader v-if="isLoading"></DefaultLoader>
            </div>
            <template v-else-if="generatedDisbursementList.length > 0">
              <div class="row">
                <div class="col-md-12">
                  <div class="table-responsive">
                    <table class="table mt-3">
                      <thead>
                        <tr>
                          <th>File Name</th>
                          <th>Disbursement Completed</th>
                          <th>Disbursement Status</th>
                          <th>Disbursed on</th>
                          <th>Download Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-for="disburse in generatedDisbursementList"
                          :key="disburse.fileName"
                        >
                          <tr>
                            <td>
                              <router-link
                                :to="`/trip-request/partners/disbursement/view/details/${disburse.fileName}/${disbursementFilter.service_type}`"
                              >
                                {{ formatDateUsingMoment(disburse.fileName) }}
                              </router-link>
                            </td>
                            <td>
                              {{ disburse.completedDisbursement }} /
                              {{ disburse.allDisbursement }}
                            </td>
                            <td
                              v-if="disburse.disbursementStatus === 'Disbursed'"
                            >
                              <p class="disbursed-rectangle">Disbursed</p>
                            </td>
                            <td
                              v-else-if="
                                disburse.disbursementStatus ===
                                'Partially Disbursed'
                              "
                            >
                              <p class="partially-disbursed-rectangle">
                                Partially Disbursed
                              </p>
                            </td>
                            <td
                              v-else-if="
                                disburse.disbursementStatus === 'Pending'
                              "
                            >
                              <p class="pending-rectangle">Pending</p>
                            </td>
                            <td>
                              {{
                                disburse.disburseDate
                                  ? formatDateUsingMoment(disburse.disburseDate)
                                  : 'N/A'
                              }}
                            </td>
                            <td v-if="disburse.downloadStatus == 'Downloaded'">
                              <p class="download-rectangle">Downloaded</p>
                            </td>
                            <td v-else>
                              <p class="pending-rectangle">Pending</p>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <NoDataMessage v-else></NoDataMessage>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Multiselect from '@vueform/multiselect';
// import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import moment from 'moment';
import http from '../../config/axios';
// import Pagination from '../pagination/Pagination';
import AttendancePagesHeading from '../attendancePages/AttendancePagesHeading.vue';

export default {
  name: 'DisbursementView',
  components: {
    // Multiselect,
    // Datepicker,
    // Pagination,
    AttendancePagesHeading
  },
  data() {
    return {
      disbursementFilter: {
        status: '',
        downloadStatus: '',
        service_type: localStorage.getItem('serviceType')
      },
      paginationValue: '20',
      statusOption: ['Disbursed', 'Partially Disbursed', 'Pending'],
      downloadOption: ['Downloaded', 'Pending'],
      disbursementList: {},
      // totalPages: 0,
      // total: 0,
      // currentPage: 1,
      // perPage: 0,
      // pageCount: '',
      // to: 0,
      // from: 0,
      isLoading: true,
      tzoffset: new Date().getTimezoneOffset() * 60000,
      preDefinedDate: null,
      date: null
    };
  },
  mounted() {
    this.getDateFromParam();
    // this.getDisbursementList();
  },
  watch: {
    'disbursementFilter.status': {
      handler: function () {
        this.getDisbursementList();
      }
    },
    'disbursementFilter.downloadStatus': {
      handler: function () {
        this.getDisbursementList();
      }
    },
    'disbursementFilter.service_type': {
      handler: function () {
        this.getDisbursementList();
      }
    },
    paginationValue: {
      handler: function () {
        this.getDisbursementList();
      }
    },
    date: {
      handler: function () {
        this.disbursementList = {};
        this.getDisbursementList();
      },
      deep: true
    }
  },
  computed: {
    generatedDisbursementList: function () {
      let generatedDisbursementList = [];

      for (const key in this.disbursementList) {
        let totalDisbursement = this.disbursementList[key].length;
        let completedDisbursement = 0;
        let downloadedDisbursement = 0;
        let disbursementStatus = 'Pending';
        let downloadStatus = 'Pending';
        let disburseDate = null;

        this.disbursementList[key].forEach((element) => {
          if (element.disbursed == 1) {
            completedDisbursement++;
            disbursementStatus = 'Partially Disbursed';

            let disbursedOn = new Date(element.disbursed_on);
            if (disburseDate) {
              if (disbursedOn > disburseDate) {
                disburseDate = disbursedOn;
              }
            } else {
              disburseDate = disbursedOn;
            }
          }

          if (element.downloaded) {
            downloadedDisbursement++;
          }
        });

        if (completedDisbursement >= totalDisbursement) {
          disbursementStatus = 'Disbursed';
        }
        if (downloadedDisbursement >= totalDisbursement) {
          downloadStatus = 'Downloaded';
        }

        let data = {};
        data.fileName = key;
        data.allDisbursement = totalDisbursement;
        data.completedDisbursement = completedDisbursement;
        data.disbursementStatus = disbursementStatus;
        data.disburseDate = disburseDate;
        data.downloadStatus = downloadStatus;

        generatedDisbursementList.push(data);
      }

      return generatedDisbursementList;
    }
  },
  methods: {
    formatDateUsingMoment(date) {
      return moment(date).format('D MMMM YYYY');
    },
    pageReload() {
      location.reload();
    },
    toCamelCaseConvert(str) {
      return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
          return index == 0 ? word.toLowerCase() : word.toUpperCase();
        })
        .replace(/\s+/g, '');
    },
    changeDate(selectedDate) {
      this.date = selectedDate;
    },
    getDateFromParam() {
      this.preDefinedDate = this.$route.params.date;
    },
    filterSearch(searchValues) {
      this.disbursementFilter = {
        status: '',
        downloadStatus: '',
        service_type: localStorage.getItem('serviceType')
      };
      for (const key in searchValues) {
        this.disbursementFilter[key] = searchValues[key];
      }
    },
    getDisbursementList(value) {
      this.isLoading = true;
      let startDate = new Date(this.date[0] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      let endDate = new Date(this.date[1] - this.tzoffset)
        .toISOString()
        .substring(0, 10);

      http
        .get(
          `v2/partners/transaction/disbursement/analytics?transaction_date_starts=${startDate}&transaction_date_ends=${endDate}&page=${value}&pagination=${
            this.paginationValue
          }&disbursement_status=${this.toCamelCaseConvert(
            this.disbursementFilter.status
          )}&download_status=${this.toCamelCaseConvert(
            this.disbursementFilter.downloadStatus
          )}&service_type=${this.disbursementFilter.service_type}`
        )
        .then((response) => {
          if (response.status === 200) {
            this.disbursementList = response.data.data;
            // this.total = response.data.data.total;
            // this.totalPages = response.data.data.last_page;
            // this.currentPage = response.data.data.current_page;
            // this.perPage = response.data.data.per_page;
            // this.to = response.data.data.to;
            // this.from = response.data.data.from;
            this.isLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
          this.isLoading = false;
        });
    }
  }
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>

<style scoped>
.bill-disbursement {
  font-family: Montserrat;
}
p {
  margin: 0;
}
.disbursed-rectangle {
  /* position: absolute; */
  width: 100px;
  height: 27px;
  background-color: #d9ffd9;
  border-radius: 66px;
  text-align: center;
  color: #00ab30;
  padding: 2px 0px;
}

.partially-disbursed-rectangle {
  /* position: absolute; */
  width: 190px;
  height: 27px;
  background-color: #d9dfff;
  border-radius: 66px;
  text-align: center;
  color: #0a30ef;
  padding: 2px 0px;
}

.pending-rectangle {
  /* position: absolute; */
  width: 100px;
  height: 27px;
  background-color: #ffecde;
  border-radius: 66px;
  text-align: center;
  color: #fd9144;
  padding: 2px 0px;
}

.attendance-tabs a {
  font-weight: 600;
}

table tbody td {
  font-size: 14px;
  font-weight: normal;
}

.download-rectangle {
  /* position: absolute; */
  width: 118px;
  height: 27px;
  background-color: #d9ffd9;
  border-radius: 66px;
  text-align: center;
  color: #00ab30;
  padding: 2px 0px;
}

table {
  align-content: center;
}

table thead {
  background-color: #f3f3f3;
  font-weight: bold;
}

table tbody {
  border-top: none !important;
}

table th,
table td {
  vertical-align: middle;
  padding: 0.5rem;
}
</style>
